import React from 'react';
import Link from 'next/link';

interface BreadcrumbLinkProps {
  href: string;
  label: string;
  isActive: boolean;
  onClick?: () => void;
}

const BreadcrumbLink: React.FC<BreadcrumbLinkProps> = ({
  href,
  label,
  isActive,
  onClick,
}) => (
  <Link
    href={href}
    className={`text-xs text-neutral-600 hover:text-neutral-700 transition-colors duration-200 ease-in-out ${
      isActive ? 'text-sky-600 font-semibold' : ''
    }`}
    aria-current={isActive ? 'page' : undefined}
    data-testid={`breadcrumb-link-${label.toLowerCase()}`}
    onClick={() => {
      if (onClick) {
        onClick();
      }
    }}
  >
    {label}
  </Link>
);

export default BreadcrumbLink;
